import React, {useEffect, useState} from "react";
import SimpleTable from "../../../common/tables/SimpleTable";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import MaterialUiSimpleSelect from "../../../common/selects/MaterialUiSimpleSelect";
import {useDispatch, useSelector} from "react-redux";
import {deleteCapNameItem, loadCapNames, saveOrUpdateCapNameItem} from "../../../../actions/capNamesActions";
import {loadCampaignNames, loadCapOfferNames} from "../../../../actions/capActions";


export default function CapNameTable({}) {

    const dispatch = useDispatch();
    const capNames = useSelector(state => state.capNamesReducer.capNames);
    const capOffersDropdown = useSelector(state => state.capReducer.capOfferNames);
    const campaignsDropdown = useSelector(state => state.capReducer.capCampaignNames);
    const [editableCapItem, setEditableCapItem] = useState({});

    useEffect(() => {
        dispatch(loadCapNames());
        dispatch(loadCapOfferNames());
        dispatch(loadCampaignNames());
    }, []);


    const handleSetEditableCapItem = (item) => {
        const editableCapItem = {...item, binomOfferName: {name: item.binomOfferName}, binomCampaign: {name: item.binomCampaign}}
        setEditableCapItem(editableCapItem);
    };

    const handleEditItem = (fieldName, value) => {
        const editableItem = {...editableCapItem, [fieldName] : value};
        setEditableCapItem(editableItem)
    };

    const handleSaveCapNameItem = () => {
        if (!editableCapItem || editableCapItem === {} || !editableCapItem.name || !editableCapItem.binomOfferName
            || !editableCapItem.binomCampaign) {
            return;
        }
        const body = {...editableCapItem,
            binomOfferName: editableCapItem.binomOfferName?.name,
            binomCampaign: editableCapItem.binomCampaign?.name
        };
        dispatch(saveOrUpdateCapNameItem(body, afterSaveOrDeleteCallback));

    };

    const handleDeleteCapNameItem = (capNameItem) => {
        handleClearEditableCapItem();
        dispatch(deleteCapNameItem(capNameItem, afterSaveOrDeleteCallback));
    };

    const afterSaveOrDeleteCallback = () => {
        setEditableCapItem({});
        dispatch(loadCapNames());
    };

    const handleClearEditableCapItem = () => {
        setEditableCapItem({});
    };

    const tableColumns = () => {
        return [
            {
                name: "Название капы",
                key: "name",
                getBodyCellValue: item => item["name"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Название оффера в трекере",
                key: "binomOfferName",
                getBodyCellValue: item => item["binomOfferName"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Кампания",
                key: "binomCampaign",
                getBodyCellValue: item => item["binomCampaign"],
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "",
                key: "actions",
                getBodyCellValue: (capNameItem) => <>
                    <i className="ti ti-pencil td-save" title="Редактировать"
                       onClick={() =>  handleSetEditableCapItem(capNameItem)}
                    />
                    <i className="ti ti-close td-save" onClick={() => handleDeleteCapNameItem(capNameItem)}
                          title="Удалить"/>
                </>,
                bodyCellStyle: {textAlign: "left", minWidth: "105px", width: "105px", paddingRight: "15px"},
                isSortingDisabled: true,
            },
        ]
    };

    const tableActionRow = () => {
        return [
            {
                key: "name",
                getActionCellValue: () => <input
                    name="name"
                    className="form-control"
                    value = {editableCapItem["name"] || ""}
                    onChange={(e) => handleEditItem("name", e.target.value)}/>
            },
            {
                key: "binomOfferName",
                getActionCellValue: () => <MaterialUiSimpleSelect
                    dropdownData={capOffersDropdown}
                    selectedValue={editableCapItem["binomOfferName"]}
                    onSelectValue={(value) => handleEditItem("binomOfferName", value)}
                    dataField='name'
                    displayedField='name'
                    isClearable
                    isSearchable
                />
            },
            {
                key: "binomCampaign",
                getActionCellValue: () => <MaterialUiSimpleSelect
                    dropdownData={campaignsDropdown}
                    selectedValue={editableCapItem["binomCampaign"]}
                    onSelectValue={(value) => handleEditItem("binomCampaign", value)}
                    dataField='name'
                    displayedField='name'
                    isClearable
                    isSearchable
                />
            },
            {
                key: "action",
                getActionCellValue: () => <>
                    <i className="ti ti-close td-save" onClick={handleClearEditableCapItem} title='Очистить'/>
                    <i className="ti ti-save td-save" onClick={handleSaveCapNameItem}
                       title = {'Сохранить'}/>
                </>
            },

        ]
    };

    const height = useResizeObserver(document.getElementById("scrollable")).height - 50;

    return (
        <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{height: height + "px"}}>
            <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext" columns={tableColumns()}
                         data={capNames} bodyRowKey="id" actionRow={tableActionRow()}/>
        </div>
    )
};